import { createContext } from 'react'

//Types
import { CDC, Collection } from 'types/cdc'
import { DocsetInfo} from 'types/docset'
import { FeatureFlag } from 'types/feature-flag'

export const CollectionContext = createContext<Collection|undefined>(undefined)

export const CDCContext = createContext<CDC|undefined>(undefined)

export const DocsetContext = createContext<DocsetInfo|undefined>(undefined)

export const FeatureFlagsContext = createContext<FeatureFlag[]|[]>([])

export const RequestorContext = createContext<string | null>(null)

export const SecureContext = createContext({secure:false, setSecureContext: (isSecure:boolean)=>{}})

export const ToggleSecureContext = createContext({secureToggled: false, toggleSecure: () => {}})

export const CurrentContentContext = createContext({currentContent: {alias: '', cfr: '', page: ''}, setCurrentContentContext: (alias: string, cfr: string, page: string)=>{}})

export const ToggleUnavailableContext = createContext({unavailableToggled: '', toggleUnavailable: (flag:string) => {}})

export const ParentSortContext = createContext({parentSort:false, setParentSortContext: (isParentSort:boolean)=>{}})

export const NodeInfoContext = createContext({nodeInfo: {embeddedNode: false, parentTitle: '', parentPage: '', parentDocset: ''}, setNodeInfoContext: (embeddedNode: boolean, parentTitle: string, parentPage: string, parentDocset:string)=>{}})